import { render, staticRenderFns } from "./dictionary_page.vue?vue&type=template&id=aea53c76&scoped=true"
import script from "./dictionary_page.vue?vue&type=script&lang=js"
export * from "./dictionary_page.vue?vue&type=script&lang=js"
import style0 from "./dictionary_page.vue?vue&type=style&index=0&id=aea53c76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea53c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea53c76')) {
      api.createRecord('aea53c76', component.options)
    } else {
      api.reload('aea53c76', component.options)
    }
    module.hot.accept("./dictionary_page.vue?vue&type=template&id=aea53c76&scoped=true", function () {
      api.rerender('aea53c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/dictionary_page.vue"
export default component.exports